import styled from "styled-components";

import { LogoPayPo } from '../../../assets/images';

export const SLogoPayPo = styled(LogoPayPo)`
    width: 14.1rem;
    height: 4rem;
`;
